import { Identifier, Timestamp } from 'types/utilityTypes';

export interface ActivityData {
  fieldName?: string;
  image?: string;
  name?: string;
  notes?: string;
  photoUrl?: string;
  totalTime?: number;
  totalWeight?: string;
  value?: string;
  workoutDate?: string;
  location?: string;
  dataString?: string;
}

export interface ActivityComment {
  id: Identifier;
  content: string;
  createdAt: Timestamp;
  user: {
    id: Identifier;
    nickname: string;
    image: string;
    url: string;
  };
}

export interface Activity {
  id: Identifier;
  activityType: number;
  body?: string;
  comments: ActivityComment[];
  createdAt: Timestamp;
  data: ActivityData;
  image?: string;
  images?: Array<{
    url: string;
    thumb?: string | null;
    thumbGif?: string | null;
  }>;
  videos?: Array<{
    id: Identifier;
    playbackId: string;
    downloadable: boolean;
    url: string;
  }>;
  voiceMemo?: string | null;
  likesCount: number;
  userLikes: Identifier[];
  userAvatar?: string;
  userId: Identifier;
  userSlug: string;
  userName: string;
  editing?: boolean;
  dataString?: string;
  string?: string;
  viaLink?: string;
  pinned?: boolean;
  disableComments?: boolean;
  commentsCount: number;
}

export interface ActivityLike {
  id: Identifier;
  userId: Identifier;
  activityId: Identifier;
  createdAt: Timestamp;
}

export enum ActivityType {
  Workout = 1,
  Assessment = 30,
  GroupActivity = 16,
}
